import React, { useMemo } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { Meta, useWorkplacePartnerQuery } from '../../../graphql/graphql';
import { Partner } from '../Enums/Partner.enum';
export default function useScope() {
	const { globalTemplate, workplaceId } = useAppContext();
	const workplacePartner = useWorkplacePartnerQuery({
		id: workplaceId,
	});

	const isKDARWorkplace = useMemo(() => {
		return workplacePartner?.data?.workplace?.partnerId === Partner.KDAR;
	}, [workplacePartner]);

	const isUnicare = useMemo(() => {
		return workplacePartner?.data?.workplace?.partnerId === Partner.UNICARE;
	}, [workplacePartner]);

	const minimalPriceInputValue = useMemo(() => {
		switch (globalTemplate) {
			case 'peru':
				return 0.5;
			case 'ecuador':
				return 0.1;
			case 'mexico':
				return 2;
			case 'colombia':
				return 430;
			case 'slovakia':
				return 0.1;
			case 'czechia':
			default:
				return 1;
		}
	}, [globalTemplate]);

	const countryCode: string = useMemo(() => {
		switch (globalTemplate) {
			case 'peru':
				return 'PE';
			case 'ecuador':
				return 'EC';
			case 'mexico':
				return 'MX';
			case 'colombia':
				return 'CO';
			case 'slovakia':
				return 'SK';
			case 'poland':
				return 'PL';
			case 'hungary':
				return 'HU';
			case 'greece':
				return 'GR';
			case 'serbia':
				return 'RS';
			case 'czechia':
			default:
				return 'CZ';
		}
	}, [globalTemplate]);

	const isHungary = globalTemplate === 'hungary';
	const isSlovakia = globalTemplate === 'slovakia';
	const isPoland = globalTemplate === 'poland';
	const isLatam = ['peru', 'ecuador', 'mexico', 'colombia'].includes(
		globalTemplate,
	);

	return {
		minimalPriceInputValue,
		isKDARWorkplace,
		isHungary,
		isSlovakia,
		isUnicare,
		isLatam,
		isPoland,
		countryCode,
	};
}
